import React from 'react'

import {
  AlignItems,
  Box,
  Col,
  Color,
  Display,
  FontWeight,
  Grid,
  Space,
  Text,
  TextAlign,
} from '@gousto-internal/citrus-react'

import { CONTROL_DISCOUNT_VALUES } from '../boxPricesConfig'

type DiscountPerWeekProps = {
  discountValues?: string[]
}

export const DiscountPerWeek = ({
  discountValues = CONTROL_DISCOUNT_VALUES,
}: DiscountPerWeekProps) => {
  const discountWeeks = [
    'Today',
    'Week 2',
    'Week 3',
    'Week 4',
    'Week 5',
    'Week 6',
    'Week 7',
    'Week 8',
  ]

  const tiles = discountWeeks.slice(0, discountValues.length)
  // Mobile shows four tiles per row; a final row of two starts at column 4 so it sits centred
  const centredTileIndex = tiles.length % 4 === 2 ? tiles.length - 2 : -1

  return (
    <Box display={Display.Flex} data-testid="discount-per-week">
      <Grid columnGap={2}>
        {tiles.map((week, index) => (
          <Col
            key={week}
            gridColumn={[
              index === centredTileIndex ? '4 / span 3' : 'auto / span 3',
              index === centredTileIndex ? '4 / span 3' : 'auto / span 3',
              'auto / span 2',
              'auto / span 2',
            ]}
          >
            <Box>
              <Box
                bg={Color.Primary_600}
                borderRadius={1.5}
                width="64px"
                height="64px"
                display={Display.Flex}
                alignItems={AlignItems.Center}
              >
                <Text
                  size={5}
                  color={Color.White}
                  fontWeight={FontWeight.Bold}
                  textAlign={TextAlign.Center}
                >
                  {discountValues[index]}
                </Text>
              </Box>

              <Space size={1} />

              <Text size={2} color={Color.ColdGrey_800} textAlign={TextAlign.Center}>
                {week}
              </Text>
              <Space size={2} />
            </Box>
          </Col>
        ))}
      </Grid>
    </Box>
  )
}
